var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecretExpiryWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.307,
    height: 13.114,
    viewBox: "0 0 14.307 13.114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9622",
    "data-name": "Group 9622",
    transform: "translate(-1116 -457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_11",
    "data-name": "Polygon 11",
    d: "M6.275,1.609a1,1,0,0,1,1.756,0L13.5,11.636a1,1,0,0,1-.878,1.479H1.685a1,1,0,0,1-.878-1.479Z",
    transform: "translate(1116 457)",
    fill: "#eb9330"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9621",
    "data-name": "Group 9621",
    transform: "translate(1122.461 460.692)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7206",
    "data-name": "Rectangle 7206",
    width: 1.394,
    height: 5.575,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7207",
    "data-name": "Rectangle 7207",
    width: 1.394,
    height: 1.394,
    transform: "translate(0 6.504)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecretExpiryWarning);
export default __webpack_public_path__ + "static/media/secret_expiry_warning.1e5df5340ee42d65d6d512412eb8210a.svg";
export { ForwardRef as ReactComponent };